import PropTypes from "prop-types";
import slideType from "./slideType";
import descriptionType from "./descriptionType";

export default PropTypes.shape({
  slides: PropTypes.arrayOf(slideType).isRequired,
  description: descriptionType.isRequired,
  showProfileCompletion: PropTypes.bool.isRequired,
  isRecruiter: PropTypes.bool,
});
